import { BuildingInput } from 'src/types/buildings-input';

const errorFinder = (buildings: BuildingInput[] = []) => {
  const errorFinder = buildings.filter(building => {
    let hasError = false;
    for (const i in building) {
      if(!building[i]) {
        hasError = true;
      }
    }
    return hasError;
  })
  return Boolean(errorFinder.length);
}

export default (state: any, action: any) => {
  const { type, index, prop, value } = action.payload;
  const { buildings } = state
  const newBuildings = [...buildings]
  const length = newBuildings.length;
  let hasError;
  switch (action.type) {
    case "BUILDINGS_COUNT_CHANGE":
      if (type === 'inc' && length < 99) {
        newBuildings.push(new BuildingInput())
      } else if (type === 'dec' && length > 1) {
        newBuildings.splice(newBuildings.length - 1, 1);
      }
      hasError = errorFinder(newBuildings);
      return {
        ...state,
        hasError,
        buildings: newBuildings,
      };
      case "INPUT_CHANGE":
        newBuildings[index][prop] = value;
        hasError = errorFinder(newBuildings)
        return {
          ...state,
          buildings: newBuildings,
          hasError,
        };
    default:
      return state;
  }
};